import inventozenHorizontal from "@/assets/images/InventoZen_Logo_Horizontal_SML.png";
import { cn } from "@/lib/utils";
import { HTMLProps } from "react";

const InventoZen = ({ className, ...props }: HTMLProps<HTMLImageElement>) => (
  <img
    src={inventozenHorizontal}
    alt="logo"
    className={cn("w-full h-6 object-contain", className)}
    {...props}
  />
);

export default InventoZen;
